import { render, staticRenderFns } from "./index.vue?vue&type=template&id=01b3f466&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=01b3f466&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b3f466",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-airdrop-manager-fe/treasurenet-tnservices-airdrop-manager-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b3f466')) {
      api.createRecord('01b3f466', component.options)
    } else {
      api.reload('01b3f466', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=01b3f466&scoped=true", function () {
      api.rerender('01b3f466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageBottom/index.vue"
export default component.exports